import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet-async';

import GenericMeta from '../GenericMeta';

const OGPProduct = ({
  price,
  currency,
  availability,
  manufacturer,
  retailerItemId,
  itemGroupId,
}) => {
  const isValidPrice = typeof price === 'number' && price > 0;
  const isValidManufacturer = !!manufacturer && manufacturer !== '0';
  const isValidRetailerItemId = !!retailerItemId && retailerItemId !== '0';
  const isValidItemGroupId = !!itemGroupId && itemGroupId !== '0';

  return (
    <>
      <Helmet>
        <html prefix="product: https://ogp.me/product#" />
      </Helmet>
      {isValidPrice && (
        <GenericMeta
          property="product:price:amount"
          content={price.toString()}
        />
      )}
      {!!currency && (
        <GenericMeta property="product:price:currency" content={currency} />
      )}
      {!!availability && (
        <GenericMeta property="product:availability" content={availability} />
      )}
      {isValidManufacturer && (
        <GenericMeta property="product:brand" content={manufacturer} />
      )}
      {isValidRetailerItemId && (
        <GenericMeta
          property="product:retailer_item_id"
          content={retailerItemId}
        />
      )}
      {isValidItemGroupId && (
        <GenericMeta property="product:item_group_id" content={itemGroupId} />
      )}
    </>
  );
};

OGPProduct.propTypes = {
  currency: PropTypes.string,
  price: PropTypes.number,
  availability: PropTypes.string,
  manufacturer: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  retailerItemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  itemGroupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default OGPProduct;
